module.exports = __webpack_public_path__ + "img/11bdf45.png";